<div [ngClass]="['vox-avatar-circular', sizeClass]">
  <img *ngIf="user?.avatar" width="100%" [src]="user?.avatar" alt="profile picture"/>
  <span *ngIf="!user?.avatar">{{ initials }}</span>
  <ng-content></ng-content>
</div>
